import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mortgageAmount: "300000",
    intrestRate: "3.5",
    loanTerm: "30",
    newLoanTerm: "25",
    newIntrestRate: '2.5',
    mortgagePoints: '1',
    refinancingCost: '1500',
    cashOut: '2500',
    startDate: new Date('2025-01-24'),
    newStartDate: new Date('2025-05-14'),
    mortageErrors: null,
    newAmount: '0',
    calculationResults: null

};

const mortgageSlice = createSlice({
    name: 'mortgageCalculator',
    initialState,
    reducers: {
        setMortagegAmount: (state, action) => {
            state.mortgageAmount = action.payload
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload
        },
        setNewStartDate: (state, action) => {
            state.newStartDate = action.payload
        },
        setIntrestRate: (state, action) => {
            state.intrestRate = action.payload
        },
        setLoanTerm: (state, action) => {
            state.loanTerm = action.payload
        },
        setNewLoanTerm: (state, action) => {
            state.newLoanTerm = action.payload
        },
        setNewIntrestRate: (state, action) => {
            state.newIntrestRate = action.payload
        },
        setMortagePoints: (state, action) => {
            state.mortgagePoints = action.payload
        },
        setRefinancingCost: (state, action) => {
            state.refinancingCost = action.payload
        },
        setCashOut: (state, action) => {
            state.cashOut = action.payload
        },
        setMortageErrors: (state, action) => {
            state.mortageErrors = action.payload
        },
        setNewAmount: (state, action) => {
            state.newAmount = action.payload
        },
        setCalculationResults: (state, action) => {
            state.calculationResults = action.payload
        },
        resetMortgageData: (state) => {
            return initialState;
        },
    }
});
export const { setRefinancingCost, setCashOut, setNewAmount, setStartDate, setNewStartDate, setMortageErrors, setMortagegAmount, setIntrestRate, setLoanTerm, setNewLoanTerm, setNewIntrestRate, setMortagePoints, setCalculationResults, resetMortgageData } = mortgageSlice.actions;
export default mortgageSlice.reducer;
export const { setActiveCalculator } = mortgageSlice.actions;